export type EprintPrintLayout = {
  paperInfo: string
  paperNumb: string
  paperNumb2: string
  printType: string
  printFlag: string
}

const BY_FORMAT_ID: Record<string, EprintPrintLayout> = {
  rirekisho_single: {
    paperInfo: '片面',
    paperNumb: '1',
    paperNumb2: '2',
    printType: '6',
    printFlag: 'onepage'
  },
  rirekisho_arbeit_debut: {
    paperInfo: '片面',
    paperNumb: '1',
    paperNumb2: '2',
    printType: '6',
    printFlag: 'onepage'
  },
  rirekisho_nophoto: {
    paperInfo: '片面',
    paperNumb: '4',
    paperNumb2: '2',
    printType: '1',
    printFlag: 'nophotoshot'
  },
  rirekisho_nophoto_double: {
    paperInfo: '両面',
    paperNumb: '4',
    paperNumb2: '3',
    printType: '2',
    printFlag: 'nophotolong'
  },
  shokumukeirekisho: {
    paperInfo: '両面',
    paperNumb: '最大4',
    paperNumb2: '9',
    printType: '11',
    printFlag: 'keireki'
  },
  rirekisho_job_new_single: {
    paperInfo: '片面',
    paperNumb: '4',
    paperNumb2: '8',
    printType: '6',
    printFlag: 'onepage'
  },
  entrysheet: {
    paperInfo: '片面',
    paperNumb: '4',
    paperNumb2: '8',
    printType: '6',
    printFlag: 'onepage'
  },
  shiboudoukisho: {
    paperInfo: '片面',
    paperNumb: '1',
    paperNumb2: '1',
    printType: '1',
    printFlag: 'shiboudoukisho'
  },
  rirekisho_design_002: {
    paperInfo: '両面',
    paperNumb: '1',
    paperNumb2: '3',
    printType: '12',
    printFlag: 'design002'
  },
  english_resume: {
    paperInfo: '片面',
    paperNumb: '最大2',
    paperNumb2: '5',
    printType: '12',
    printFlag: 'basic'
  },
  letter: {
    paperInfo: '両面',
    paperNumb: '1',
    paperNumb2: '3',
    printType: '13',
    printFlag: 'letter'
  },
  taishokutodoke: {
    paperInfo: '両面',
    paperNumb: '1',
    paperNumb2: '3',
    printType: '13',
    printFlag: 'letter'
  }
}

const DEFAULT_LAYOUT: EprintPrintLayout = {
  paperInfo: '両面',
  paperNumb: '1',
  paperNumb2: '3',
  printType: '12',
  printFlag: 'basic'
}

const KEIREKI_LAYOUT = BY_FORMAT_ID.shokumukeirekisho

export function layoutFromFormatId(formatId: string): EprintPrintLayout {
  if (BY_FORMAT_ID[formatId]) return { ...BY_FORMAT_ID[formatId] }
  if (formatId.indexOf('shokumukeirekisho') >= 0) {
    return { ...KEIREKI_LAYOUT }
  }
  return { ...DEFAULT_LAYOUT }
}
